import CaretRightIcon from "@medoma/components/icons/CaretRightIcon";
import type { IUnstyledLink } from "@medoma/components/Link/Link";
import { UnstyledLink } from "@medoma/components/Link/Link";
import styles from "./ActionCard.module.scss";
import { Text } from "@medoma/components/Text/Text";

type IActionCardBase = {
  icon?: React.ReactNode;
  title: string;
  weight?: "regular" | "bold";
  children?: React.ReactNode;
};

type IActionCardLink = IActionCardBase & StrictOmit<IUnstyledLink, "title">;

export const ActionCardLink = ({
  icon,
  title,
  weight = "regular",
  children,
  ...rest
}: IActionCardLink) => {
  return (
    <UnstyledLink aria-label={title} {...rest}>
      <article className={styles.card}>
        <div className={styles.titleRow}>
          <div className={styles.start}>
            {icon ? (
              <span className={styles.iconWrapper}>{icon}</span>
            ) : undefined}
            <Text element="span" size="large" weight={weight}>
              {title}
            </Text>
          </div>
          <div className={styles.end}>
            <CaretRightIcon />
          </div>
        </div>
        {children ? (
          <div className={styles.content}>{children}</div>
        ) : undefined}
      </article>
    </UnstyledLink>
  );
};

type IActionCardButton = IActionCardBase & {
  onClick: () => void;
  disabled?: boolean;
};

export const ActionCardButton = ({
  icon,
  title,
  weight = "regular",
  children,
  disabled,
  onClick,
}: IActionCardButton) => {
  return (
    <button
      className={styles.button}
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
    >
      <article className={styles.card}>
        <div className={styles.titleRow}>
          <div className={styles.start}>
            <span className={styles.iconWrapper}>{icon}</span>
            <Text element="span" size="large" weight={weight}>
              {title}
            </Text>
          </div>
        </div>
        {children ? (
          <div className={styles.content}>{children}</div>
        ) : undefined}
      </article>
    </button>
  );
};
